import { useMemo } from 'react';
import { FieldError, Merge } from 'react-hook-form';

export type FormTagVariant = 'default' | 'warning' | 'error';

export type TagFieldValidationMessage = {
  variant: FormTagVariant;
  message: string;
  tag: string;
};

export const createTagFieldValidationStringMessage = (
  message: TagFieldValidationMessage
): string => JSON.stringify(message);

export const transformStringTagFieldValidationMessage = (
  stringMessage: string
): TagFieldValidationMessage | null => {
  try {
    const message = JSON.parse(stringMessage);
    const isCorrectMessage =
      typeof message === 'object' &&
      'variant' in message &&
      'message' in message &&
      'tag' in message;

    return isCorrectMessage ? message : null;
  } catch (e) {
    console.error(e);

    return null;
  }
};

export const useTagErrors = (error?: FieldError) =>
  useMemo(() => {
    try {
      return Array.isArray(error)
        ? (error
            .map(error =>
              transformStringTagFieldValidationMessage(error.message)
            )
            .filter(Boolean) as TagFieldValidationMessage[])
        : [];
    } catch (e) {
      console.error(e);

      return [];
    }
  }, [error]);

export const useParsedTagErrors = (
  error?: Merge<FieldError, (FieldError | undefined)[]> | undefined
) =>
  useMemo(() => {
    try {
      return Array.isArray(error)
        ? (
            error
              .map(error =>
                transformStringTagFieldValidationMessage(error.message)
              )
              .filter(Boolean) as TagFieldValidationMessage[]
          ).sort(a => (a.variant === 'error' ? -1 : 1))
        : [];
    } catch (e) {
      console.error(e);

      return [];
    }
  }, [error]);
